import http from 'utils/http';
export const getGateways = async (store_id) => {
  const res = await http.get(`/config/gateway/${store_id}`);
  return res?.data?.data;
};

export const deleteGatewayInstance = async (store_id, instance_id) => {
  const res = await http.delete(`/config/instance/${store_id}?instance_id=${instance_id}`);
  return res?.data?.data;
};

export const createGatewayInstance = async (store_id, payload) => {
  const res = await http.post(`/config/gateway/${store_id}`, payload);
  return res?.data?.data;
};

export const updateGatewayInstance = async (store_id, payload) => {
  const res = await http.put(`/config/gateway/${store_id}`, payload);
  return res?.data?.data;
};
